// extracted by mini-css-extract-plugin
export var deleteIcon = "_pc-5";
export var deleteOption = "_pc-3";
export var divider = "_pc-2";
export var downloadIcon = "_pc-4";
export var drawer = "_pc-0";
export var drawerFooter = "_pc-6";
export var drawerOpen = "_pc-1";
export var highlighted = "_pc-7";
export var lighterHighlight = "_pc-8";